// extracted by mini-css-extract-plugin
module.exports = {"row":"team-row_row__18jiR","remove":"team-row_remove__1xEvf","team":"team-row_team__2cN4k","name":"team-row_name__16R5Q","permission":"team-row_permission__2lEgK"};